// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--3-1pa"};